function UtilitiesList() {
  return (
    <div className="utilitiesList">
      <div className="container">
        <div className="bgrTop">
          <div className="row">
            <div className="col-lg-7 col-12 utilitiesListLeft">
              <img
                className="imgDesktop img-fluid"
                src="/images/cham-de-trai-nghiem.png"
                alt=""
              />
              <img
                className="imgMobile img-fluid"
                src="/images/chan-tan-huong.png"
                alt=""
              />
            </div>
            <div className=" col-lg-5 col-12 utilitiesListRight">
              <div className="listItem">
                <div className="content">
                  <p>Đặt phòng </p>
                  <p>không cần đặt cọc</p>
                </div>
                <div className="imgStyle">
                  <img
                    className="img-fluid"
                    src="/images/khong-dat-coc.png"
                    alt=""
                  />
                </div>
              </div>
              <div className="listItem">
                <div className="content">
                  <p>Dễ dàng kiểm tra</p>
                  <p>tình trạng phòng trống</p>
                  <p> và chọn phòng theo ý thích</p>
                </div>
                <div className="imgStyle">
                  <img
                    className="img-fluid"
                    src="/images/chon-phong.png"
                    alt=""
                  />
                </div>
              </div>
              <div className="listItem">
                <div className="content">
                  <p>Nhận phòng trước 48 giờ,</p>
                  <p> trả phòng chỉ trong 1 phút</p>
                </div>
                <div className="imgStyle">
                  <img
                    className="img-fluid"
                    src="/images/mo-khoa-phong.png"
                    alt=""
                  />
                </div>
              </div>
              <div className="listItem">
                <div className="content">
                  <p>Mở khóa phòng trên</p>
                  <p>chính điện thoại của bạn</p>
                </div>
                <div className="imgStyle">
                  <img
                    className="img-fluid"
                    src="/images/nhan-phong.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="col-12 imgBottomMobile">
              <img
                className="img-fluid"
                src="/images/img-cham-trai-nghiem-mobile.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="bgrBottom">
          <div className="row">
            <div className="col-lg-4  col-8 col-md-6">
              <h5>GURU</h5>
              <p className="slogan">
                Những đại sứ thân thiện và luôn sẵn sàng chia sẻ
              </p>
            </div>
            <div className="col-lg-2 c col-4 col-md-6 cream">
              <img className="img-fluid" src="/images/GURU-logo.png" alt="" />
            </div>
            <div className="col-lg-6 col-12 col-12">
              <p>
                Điều thú vị nhất mà SOJO mong muốn đưa đến cho bạn đó chính là
                người bạn đồng hành GURU - người luôn sẵn sàng hỗ trợ bạn trong
                kỳ nghỉ của mình bằng sự thân thiện, nhiệt thành và hiểu biết
                nhất. GURU còn là người bạn địa phương giúp bạn với những gợi ý,
                tư vấn về điểm đến cực hay ho mà tin chắc bạn sẽ vô cùng bất
                ngờ. Điều gì chưa tỏ hỏi GURU biết, điều gì khó có GURU lo!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default UtilitiesList;
